import { fileAx, fileAxWP } from "@/axiosInstance.js";
export default {
  namespaced: true,
  state: {
    fileUploadConnId: null,
    percentage: null,
    url: null,
  },
  mutations: {
    setFileUploadConnId(state, payload) {
      state.fileUploadConnId = payload;
    },
    setPercentage(state, payload) {
      state.percentage = payload;
    },
    resetUrl(state, payload) {
      state.url = null;
      state.percentage = null;
    },
    setUrl(state, payload) {
      state.url = payload;
    },
  },
  getters: {
    getPercentage: (state) => state.percentage,
    getFileUrl: (state) => state.url,
  },
  actions: {
    async uploadFile({ commit, state, rootState }, payload) {
      const { file, appKey } = payload;
      return new Promise(async (resolve, reject) => {
        const formData = new FormData();
        formData.append("file", file);

        const params = {
          path: rootState.signalRStore.customerDesc.caption || null,
          appKey: appKey,
          connectionId: state.fileUploadConnId || null,
        };

        const fullUrl = `upload-with-progress?${new URLSearchParams(
          params
        ).toString()}`;

        try {
          const response = await fileAxWP.post(fullUrl, formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          commit("setUrl", response.data.url);
          resolve(response.data);
        } catch (error) {
          commit("setUploadStatus", "error");
          reject(error);
        }
      });
    },
    async deleteFile({ commit, state, rootState }, payload) {
      return new Promise(async (resolve, reject) => {
        const encodedFilePath = encodeURIComponent(payload);
        const url = `https://storage.d7ksuper.com/api/files/delete-file?filePath=${encodedFilePath}`;

        try {
          const response = await fileAxWP.delete(url, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
          resolve(response);
        } catch (error) {
          commit("setUploadStatus", "error");
          reject(error);
        }
      });
    },
  },
};
